export const stepCampaignEnum = Object.freeze({
  sendingMode: 2,
  scheduleSending: 3,
  pacing: 4,
});
